import { jsx as _jsx } from "react/jsx-runtime";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import pointOfSale from "@faire/web-api--source/routes/point-of-sale";
import React from "react";
export var PosIntegrationBanner = function() {
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        children: /*#__PURE__*/ _jsx(ResponsiveContentV2, {
            noJS: true,
            tabletAndBelow: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "AovZ9+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Connect your POS to Faire to easily manage your inventory. "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Learn more"
                            }
                        ]
                    }
                ],
                values: {
                    LinkFormatting: LinkFormatting
                }
            }),
            desktopAndAbove: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "5a9qyM",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Do you use Shopify, Square, or Clover?"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Connect your POS to Faire to easily manage your inventory. "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Learn more"
                            }
                        ]
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    LinkFormatting: LinkFormatting
                }
            })
        })
    });
};
var LinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: pointOfSale(),
        children: chunks
    });
};
